import { KLineData } from "klinecharts";
import { klineLineStyle, lineStyleToKLine } from "./lineStyle";
import { readStyle } from "./indicatorUtils";

export const createDeMarker = (settings: any) => {
  const values = settings?.values ?? {};
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const period = (values.Period as number) ?? 14;
  const demS = readStyle(styles, "dem", "#2196F3");

  return {
    name: "demarker",
    shortName: `DeM${period}`,
    calcParams: [period],
    series: "normal" as const,
    minValue: 0,
    maxValue: 1,
    figures: [{ key: "dem", title: `DeM${period}: `, type: "line" }],
    styles: {
      lines: [klineLineStyle(demS.color, 2, lineStyleToKLine(demS.style))],
    },
    regenerateFigures: ([p]: number[]) => [
      { key: "dem", title: `DeM${p}: `, type: "line" },
    ],
    calc: (dataList: KLineData[], indicator: { calcParams?: unknown[] }) => {
      const [p] = (indicator.calcParams ?? [period]) as [number];
      const n = dataList.length;
      const results: Array<{ dem?: number }> = new Array(n);
      results[0] = {};

      let maxSum = 0;
      let minSum = 0;
      const maxBuf: number[] = new Array(p);
      const minBuf: number[] = new Array(p);
      let bufIdx = 0;
      let bufCount = 0;

      for (let i = 1; i < n; i++) {
        const deMax =
          dataList[i]!.high > dataList[i - 1]!.high
            ? dataList[i]!.high - dataList[i - 1]!.high
            : 0;
        const deMin =
          dataList[i]!.low < dataList[i - 1]!.low
            ? dataList[i - 1]!.low - dataList[i]!.low
            : 0;

        const evMax = bufCount === p ? maxBuf[bufIdx]! : 0;
        const evMin = bufCount === p ? minBuf[bufIdx]! : 0;
        maxBuf[bufIdx] = deMax;
        minBuf[bufIdx] = deMin;
        bufIdx = (bufIdx + 1) % p;
        if (bufCount < p) bufCount++;
        maxSum += deMax - evMax;
        minSum += deMin - evMin;

        if (i < p) {
          results[i] = {};
        } else {
          const denom = maxSum + minSum;
          results[i] = { dem: denom !== 0 ? maxSum / denom : 0.5 };
        }
      }

      return results;
    },
  };
};
